'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const react = require('@emotion/react');
const clsx = require('clsx');
const reactAriaComponents = require('react-aria-components');

const header = "_header_139rn_1";
const section = "_section_139rn_6";
const styles = {
	header: header,
	section: section
};

const SelectGroup = ({ children, className, label }) => {
  return react.jsx(
    reactAriaComponents.Section,
    { className: clsx.clsx(className, styles.section), "data-zds": true },
    react.jsx(reactAriaComponents.Header, { className: styles.header, "data-zds": true }, label),
    children
  );
};

exports.SelectGroup = SelectGroup;
//# sourceMappingURL=SelectGroup.cjs.js.map
